import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNumpyComponent } from './simple-icons-numpy.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNumpyComponent ],
    exports:      [ SimpleIconsNumpyComponent ],
    bootstrap:    []
})
export class SimpleIconsNumpyModule {}
